import { Component, inject } from '@angular/core';
import { PartnersService } from '../../../services/partners.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-partners-voivodeships',
    templateUrl: './partners-voivodeships.component.html',
    styleUrls: ['./partners-voivodeships.component.scss'],
    imports: [CommonModule, TranslateModule, RouterModule],
})
export class PartnersVoivodeshipsComponent {
    private partnersService = inject(PartnersService);

    readonly voivodeships$ = this.partnersService.voivodeships$;
}
